var objTicketUser = {
    // <summary>
    // This object holds all functions for user related functionality in ticket.js
    // </summary>
    contact_type_becCoach: 132,
    contact_type_becGeneral: 131,
    contact_type_extRecipients: 154,

    _setUserRights: function (me) {
        /// <summary>
        ///  This function sets user-rights based settings - mainly for various users and the top menu
        /// </summary>

        var bAllow;
        var bExecutionDone = false;
        var uid;
        var isCreator = false;
        try {
            if (me.error) {
                return false;
            }

            if (me.specific.isStaff === "false") {
                me.myHtml.topMenu.btnAccounting.hide();
                me.myHtml.topMenu.btnProjectInfo.hide();
            }

            me.editLevel = 0;
            if (me.entry.Uid === me.specific.uid) { isCreator = true; }

            if (me.owner === me.specific.uid || me.entry.Uid === me.specific.uid || me.specific.isStaff === "true") {
                bAllow = true;
                me.editLevel = me.specific.USER_OWNER_TYPEID;
            } else {
                bAllow = false;
            }

            if (!bAllow) {
                uid = me.ddlExecutor.getValue();
                if (uid.length > 0) {
                    if (!me.myHtml.rowUser.userBox.dateExecution.divDate.hasClass("vc-date")) {
                        if (parseInt(uid) === me.specific.uid) {
                            bAllow = true;
                            me.editLevel = me.specific.USER_EXECUTOR_TYPEID;
                        }
                    } else {
                        bExecutionDone = true;
                    }
                }
            }

            if (!bAllow && bExecutionDone) {
                uid = me.ddlValidator.getValue();
                if (uid.length > 0) {
                    if (!me.myHtml.rowUser.userBox.dateValidation.divDate.hasClass("vc-date")) {
                        if (parseInt(uid) === me.specific.uid) {
                            bAllow = true;
                            me.editLevel = me.specific.USER_VALIDATOR_TYPEID;

                        }
                    }
                }
            }


            return true;
        } catch (ex) { me._writeErr(ex); return false }

    },
    _getUser: function (me, entry, type) {
        /// <summary>
        ///  This function returns the user based on a given type
        /// </summary>
        var bFound = false;
        var name;

        try {
            if (me.error) { return false; }
            var user = $("<div>");
            if (entry.Users.UserTypes !== null) {
                for (var j = 0; j < entry.Users.UserTypes.length; j++) {
                    if (parseInt(entry.Users.UserTypes[j]) === type) {
                        name = entry.Users.UserNames[j];
                        if (name.length > 0) {
                            user.html(name);
                            bFound = true;
                        }
                    }
                }
            }

            if (bFound === false) {

                if (type !== me.specific.USER_VALIDATOR_TYPEID) { user.html("user not found with type:" + type); }
            } else {
                if (type === me.specific.USER_EXECUTOR_TYPEID) {
                    user.prepend($("<i>").addClass("fa fa-briefcase icon-color-info"));
                    if (entry.Data.ExecutionTime.length > 0 || entry.Done) {
                        user.append($("<i>").addClass("fa fa-check icon-color-ok").attr("title", entry.Data.ExecutionTime));
                    } else {
                        user.addClass("active-state");
                    }
                }
                if (type === me.specific.USER_VALIDATOR_TYPEID) {
                    user.prepend($("<i>").addClass("fa fa-stethoscope icon-color-info"));
                    if (entry.Data.ValidationTime.length > 0) {
                        user.append($("<i>").addClass("fa fa-check icon-color-ok").attr("title", entry.Data.ValidationTime));
                    } else {
                        user.addClass("active-state");
                    }
                }
                if (type === me.specific.USER_ACCOUNTING_TYPEID) {
                    user.prepend($("<i>").addClass("fa fa-stethoscope icon-color-info"));
                    if (entry.Data.AccountingTime.length > 0) {
                        user.append($("<i>").addClass("fa fa-check icon-color-ok").attr("title", entry.Data.AccountingTime));
                    } else {
                        user.addClass("active-state");
                    }
                }
            }

            return user;
        } catch (ex) { me._writeErr(ex); return null }

    },
    _getUserID: function (me, entry, type) {
        /// <summary>
        ///  This function returns the user id based on the given type
        /// </summary>
        var ids = [];
        try {
            if (me.error) { return ids; }

            if (entry.Users.Users !== null) {
                for (var j = 0; j < entry.Users.Users.length; j++) {
                    if (entry.Users.Users[j].TypeId === type) {
                        ids.push(entry.Users.Users[j].Uid);
                    }
                }
            }
            return ids;
        } catch (ex) { me._writeErr(ex); return ids }

    },
    _setDefaultUsers: function (me, useDefaultOwner) {
        /// <summary>
        ///  This function sets either the user of the current ticket or the system-wide default users (from the ticket template)
        /// </summary>
        try {
            if (me.error) { return false; }
            //set the owner box entries

            let entry = useDefaultOwner ? me.specific.tplTicket : me.entry;


            me.myHtml.rowUser.userBox.txtOwner.html(objTicketUser._getUser(me, entry, me.specific.USER_OWNER_TYPEID).text());
            var owner = objTicketUser._getUserID(me, entry, me.specific.USER_OWNER_TYPEID);
            me.ddlOwner.setValue(owner[0], true);
            me.owner = parseInt(owner[0]);
          

            var exec = objTicketUser._getUserID(me, entry, me.specific.USER_EXECUTOR_TYPEID);

            if (exec.length > 0) {
                me.myHtml.rowUser.userBox.txtExecutor.html(objTicketUser._getUser(me, entry, me.specific.USER_EXECUTOR_TYPEID).text());
                me.ddlExecutor.setValue(exec[0], true);
            } else {
                me.myHtml.rowUser.userBox.txtExecutor.html("");
            }

            var validator = objTicketUser._getUserID(me, entry, me.specific.USER_VALIDATOR_TYPEID);
            if (validator.length > 0) {
                me.myHtml.rowUser.userBox.txtValidator.html(objTicketUser._getUser(me, entry, me.specific.USER_VALIDATOR_TYPEID).text());
                me.ddlValidator.setValue(validator[0], true);
            } else {
                me.ddlValidator.setValue(-1, true);
                me.myHtml.rowUser.userBox.txtValidator.html("");
            }

            var accounter = objTicketUser._getUserID(me, entry, me.specific.USER_ACCOUNTING_TYPEID);
            if (accounter.length > 0) {
                me.myHtml.rowAccounting.txtAccounter.html(objTicketUser._getUser(me, entry, me.specific.USER_ACCOUNTING_TYPEID).text());
                me.ddlAccounter.setValue(accounter[0], true);
            } else {
                me.ddlAccounter.setValue(-1, true);
                me.myHtml.rowAccounting.txtAccounter.html("");
            }

        } catch (ex) { me._writeErr(e); }

    },
    _fetchContacts: function (me, blid) {
        /// <summary>
        ///  This function fetches the new project contacts and after it the new external watchlist
        /// </summary>
        try {
            if (me.error) { return false; }
            if (me.specific.readOnlyMode) return true;

            me.getData({ TypeId: 6, LoggerId: blid }, function (result) {
               
                if (result === null) { me.showMessage(me.resources.err_loadData, true); return false; }

                //reset default users;
                objTicketUser._setDefaultUsers(me, true);
                me.ddlValidator.setValue(-1, true);
                me.projectContacts = result;
                let projectOwner = (objTicketUser._getContactId(me, objTicketUser.contact_type_becCoach));  //hardcoded Logger.contactType.BecCoach

                if (projectOwner > -1) {
                    me.ddlOwner.setValue(projectOwner, true);
                    me.owner = parseInt(projectOwner);
                    //me.ddlOwner.setValue(projectOwner, true);
                    //me.owner = parseInt(projectOwner);
                    me.ddlExecutor.setValue(projectOwner, true);
                    me.ddlAccounter.setValue(projectOwner, true);
                }

                let projectValidator = (objTicketUser._getContactId(me, objTicketUser.contact_type_becGeneral));  //hardcoded Logger.contactType.BecGeneral
                if (projectValidator > -1) { me.ddlValidator.setValue(projectValidator, true); }

                //fill external watchlist (and set the new default ext. recipients)
                objTicketUser._fillExtWatchlist(me, me.entry.Blid, !me.specific.readOnlyMode);


                return true;
            });
            return true;
        } catch (ex) { me._writeErr(e); return false }

    },
    _fillExtWatchlist: function (me, blid, showAll) {
        /// <summary>
        ///  This function generates a vc-list for all users of the current project for the external watchlist
        /// </summary>

        try {
            if (me.error) { return false; }
            me.getData({ TypeId: 5, LoggerId: blid }, function (userList) {
                if (userList === null) { me.showMessage(me.resources.err_loadData, true); return false; }
             
                me._fillSublist("ext-watchlist", userList, objTicketUser._getUserID(me, me.entry, me.specific.USER_EXTERNALEMAIL_TYPEID), !me.specific.readOnlyMode, false);

                //at a new ticket, we set all users with contact type (ticket ext. recipients) to active
                if (me.entry.Id == -1) {
                    let chb = me.fnd("#div-ext-watchlist .chb-ext-watchlist");
                    for (let item of me.projectContacts) {
                        if (item.ContactType == objTicketUser.contact_type_extRecipients) { //filter ticket-ext. recipients
                            $.each(chb, function (e) {
                                if ($(this).data("id") == item.Id) { $(this).prop("checked", "checked"); }
                            });
                        }
                    }


                }

                return true;
            });

            return true;
        } catch (ex) { me._writeErr(ex); return false }

    },
    _getContactId: function (me, type) {
        /// <summary>
        ///  This function returns the first id found in project contacts for a given contact type
        /// </summary>
        try {
            if (me.error) { return false; }

            for (let item of me.projectContacts) {
                if (item.ContactType == type) return item.Id;
            }

            return -1;
        } catch (ex) { me._writeErr(e); return -1 }

    },
};